import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import SearchInput from "components/atoms/SearchInput"
import WishItemSummaryCard from "components/molecules/WishItemSummaryCard"
import WishListViewEmptyState from "components/molecules/WishListViewEmptyState"
import LoadingPlaceholder from "./LoadingPlaceholder"

type WishListViewProps = {
  list: WishItem[];
  isLoading: boolean;
  showAddNewItemButton?: boolean
}

export default function WishListView(props: WishListViewProps) {
  const { list, isLoading, showAddNewItemButton } = props

  const [localUserWishLists, setLocalUserWishLists] = useState<WishItem[]>([])

  const { t } = useTranslation()

  useEffect(() => {
    if (list) {
      setLocalUserWishLists(list)
    } else {
      setLocalUserWishLists([])
    }
  }, [list])

  function handleSearchListName(event: React.SyntheticEvent) {
    // @ts-ignore
    const searchedValue = event.target.value
    if (!list) return
    const filteredLists = list.filter(list => list.name.toLowerCase().includes(searchedValue))
    setLocalUserWishLists(filteredLists)
  }

  return (
    <>
      {list.length ? <SearchInput
        id={"search-list-input"}
        placeholder={t("items.searchItemName")}
        disabled={isLoading}
        onChange={handleSearchListName}
      /> : null}
      <>
        {!isLoading ? <>
          {list.length ? <Container>
            {localUserWishLists.map((item, index) => (
              <WishItemSummaryCard
                key={item.id}
                index={list.findIndex(i => i.id === item.id)}
                itemInfo={item}
              />
            ))}
          </Container> : <WishListViewEmptyState showAddNewItemButton={showAddNewItemButton}/>
          }
        </> : <div style={{ marginTop: list.length ? "-16px" : 0 }}>
          <LoadingPlaceholder/>
        </div>}
      </>
    </>
  )
}

const Container = styled(Stack)(({ theme }) => ({
  marginTop: "-40px",
  gap: "8px"
}))
